import { call, ForkEffect, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import toast from 'react-hot-toast';
import React from 'react';
import {
  getOrganizationById,
  getOrganizationsList,
  getOrganizationSubscription,
  updateOrganizationSubscription,
} from '../../api/organizationApi'; // Import the API function
import { ISubscription, organizationActions } from './organizationSlice';
import { authActions } from '../auth/authSlice';
import { userActions } from '../user/userSlice';
import { toastStyles } from '../../utils/styles';

function* watchGetOrganizationById(action: { payload: string }) {
  try {
    yield put(organizationActions.setComponentStatus({ getOrganizationLoading: true }));
    const res: AxiosResponse = yield call(getOrganizationById, action.payload);

    yield put(organizationActions.setComponentStatus({ getOrganizationLoading: false }));
    yield put(organizationActions.fetchOrganizationByIdSuccess(res.data));

    const accountStatus = res.data.status;
    yield put(authActions.setAccountStatus(accountStatus));
  } catch (err: any) {
    yield put(organizationActions.setComponentStatus({ getOrganizationLoading: false }));
    yield put(organizationActions.fetchOrganizationByIdFailure(err.message || 'Failed to fetch organization data'));
  }
}
function* watchGetOrganisationsList() {
  try {
    yield put(organizationActions.setComponentStatus({ getOrganisationList: true }));
    const response: AxiosResponse = yield call(getOrganizationsList);
    yield put(organizationActions.setOrganizationList(response.data.data));
    yield put(organizationActions.setComponentStatus({ getOrganisationList: false }));
  } catch (error) {
    yield put(organizationActions.setComponentStatus({ getOrganisationList: false }));
  }
}

function* watchGetOrganizationSubscription() {
  try {
    yield put(organizationActions.setComponentStatus({ getOrganizationSubscriptionLoading: true }));
    const res: AxiosResponse = yield call(getOrganizationSubscription);
    yield put(organizationActions.setComponentStatus({ getOrganizationSubscriptionLoading: false }));
    yield put(organizationActions.setOrganizationSubscription(res.data));
  } catch (err) {
    yield put(organizationActions.setComponentStatus({ getOrganizationSubscriptionLoading: false }));
  }
}

function* watchUpdateOrganizationSubscription(action: {
  payload: { organizationId: string; data: any; currentSubscription: ISubscription };
}) {
  try {
    const { organizationId, data, currentSubscription } = action.payload;
    const res: AxiosResponse = yield call(updateOrganizationSubscription, organizationId, data);
    yield put(organizationActions.updateOrganizationSubscriptionSuccess(res.data));
    const newSubscriptionName = res.data.requestedSubscription;
    if (!newSubscriptionName) {
      const updateType = res.data.subscriptionEntity.order > currentSubscription.order ? 'Upgraded' : 'Downgraded';
      toast.success(`${updateType} to the ${res.data.subscriptionEntity.name}`, toastStyles.success);
    }
    yield put(userActions.getUserAsync());
  } catch (err: any) {
    yield put(
      organizationActions.updateOrganizationSubscriptionFailure(
        err.message || 'Failed to update organization subscription',
      ),
    );
    toast.error('Failed to update organization subscription', toastStyles.error);
  }
}

export function* watchOrganizationSagas(): Generator<ForkEffect, void> {
  yield takeLatest(organizationActions.getOrganizationByIdAsync, watchGetOrganizationById);
  yield takeLatest(organizationActions.getOrganizationListAsync, watchGetOrganisationsList);
  yield takeLatest(organizationActions.getOrganizationSubscriptionAsync, watchGetOrganizationSubscription);
  yield takeLatest(organizationActions.updateOrganizationSubscriptionStart, watchUpdateOrganizationSubscription);
}

const organizationSagas = watchOrganizationSagas;
export default organizationSagas;
